import { useRouter } from 'node_modules/next/router';
import { useEffect, useState } from 'react';
import { useSSRSelector } from 'src/redux';

export const BUILDER_ACCESS_LEVEL = {
  ADMIN: 'alpha', // complete access to new builder
  MERCHANT: 'tradesman', // merchant access to new builder
  SALES: 'peddler', // sales-poc access
};

export function useGetBuilderAccessValues() {
  const { query } = useRouter();
  const { storeData } = useSSRSelector((state) => ({
    storeData: state.storeReducer.store,
  }));
  const [builderAccess, setBuilderAccess] = useState(calcBuilderAccess());

  useEffect(() => {
    setBuilderAccess(calcBuilderAccess());
  }, [query]);

  function calcBuilderAccess() {
    const hasInternalAdminAccess = storeData?.internal_admin_access === 1;
    const hasAdminAccess = !!query.loginViaAdminCreds || hasInternalAdminAccess;
    return {
      // Merchant level admin
      hasAdminAccess,
      // Company level admin to directly access merchant's store
      hasInternalAdminAccess,
      hasMerchantAdminAccess:
        query.accessLevel === BUILDER_ACCESS_LEVEL.MERCHANT &&
        hasAdminAccess &&
        !hasInternalAdminAccess,
      hasInternalAdminAccessExpired: false,
    };
  }

  return builderAccess;
}
